import { Grid } from "@mui/material";
import "./checkbox.scss";

const Checkbox = ({ value,disabled, onChange, checked, label = "Close Item",name, testId, id }) => {
  const resolvedTestId = testId || name || undefined;
  return (
    <>
      <Grid className="check">
        <input
          type="checkbox"
          className="tickbox"
          value={value}
          onChange={(e) => onChange(e)}
          checked={checked}
          name={name}
          disabled={disabled}
          data-testid={resolvedTestId}
          id={id}
        />
        <span className="closeItem">{label}</span>
      </Grid>
    </>
  );
};

export default Checkbox;
